<template>
	<TwoColumns
		first-column-class="items-center flex"
		second-column-class="contained-section order-last lg:order-none"
	>
		<template #first>
			<div class="h-full">
				<div class="flex h-full items-center">
					<CarbarImage
						image="img/electric-vehicle/img-sellyourcartoupgrade.webp"
						alt-text="Sell your car and upgrade to an EV"
					/>
				</div>
			</div>
		</template>
		<template #second>
			<h2 class="w-full text-left">
				Sell your car to us and upgrade to an electric vehicle
			</h2>
			<div class="space-y-5 text-lg text-gray-575">
				<p>Selling a car privately can take time and cost you money.</p>
				<p>
					Enjoy a fast, safe and hassle-free experience with carbar.
				</p>
				<p>
					We will always offer a competitive valuation when you choose
					to sell your car to us.
				</p>
				<p>
					The future is electric and carbar is ready to help you make
					the switch.
				</p>
			</div>
			<div class="mt-4">
				<TickList
					:items="items"
					:columns-count="1"
					class="mt-0 text-lg text-gray-575"
				/>
			</div>
			<div class="mt-8 flex flex-col text-xsm">
				<DoubleCta
					v-if="!isListingOnly"
					class="mt-8"
					:is-stacked="false"
				>
					<template #primary>
						<SellMyCarModal
							button-text="Get an instant valuation"
						/>
					</template>
					<template #secondary>
						<CarbarLink font-size="text-base" href="/sell-my-car">
							<CarbarButton
								:is-outline="true"
								:is-full-width="true"
							>
								Why sell your car to carbar?
							</CarbarButton>
						</CarbarLink>
					</template>
				</DoubleCta>
				<CarbarLink v-else font-size="text-base" href="/sell-my-car">
					<CarbarButton :is-full-width="false">
						Why sell your car to carbar?
					</CarbarButton>
				</CarbarLink>
			</div>
			<div class="mt-8">
				<TermsAndConditions :is-full-width="false">
					^ Valid for seven (7) days and is an invitation to treaty
					only, based on information provided by you and our
					assumptions. The instant valuation is not an offer to
					purchase by us.
					<CarbarLink
						href="/terms-and-conditions/instant-valuation"
						target="_blank"
						class="text-xsm"
						text="Terms and conditions"
					/>
					apply.
				</TermsAndConditions>
			</div>
		</template>
	</TwoColumns>
</template>

<script setup>
import DoubleCta from '@/components/buttons/DoubleCta.vue'
import CarbarImage from '@/components/CarbarImage.vue'
import CarbarLink from '@/components/links/CarbarLink.vue'
import TickList from '@/components/lists/TickList.vue'
import TwoColumns from '@/components/sections/TwoColumns.vue'
import CarbarButton from '@/components/buttons/CarbarButton.vue'
import SellMyCarModal from '@/components/sell-my-car/SellMyCarModal.vue'
import TermsAndConditions from '@/components/fineprint/TermsAndConditions.vue'

const items = [
	{
		label: 'Get an instant valuation^',
	},
	{
		label: "We'll organise an inspection",
	},
	{
		label: 'Get paid in advance',
	},
]

const isListingOnly = useIsListingOnly()
</script>
